export const CALENDAR_BACKGROUND_COLORS: string[] = [
  "#81E6D9",
  "#FEB2B2",
  "#FBD38D",
  "#FAF089",
  "#9AE6B4",
  "#90cdf4",
  "#9DECF9",
  "#D6BCFA",
  "#FBB6CE",
];

export const CALENDAR_TEXT_COLORS: string[] = ["#2D3748", "#ffffff"];
